import apiClient from './apiClient';

const verificationApi = {
  getPrompt: () =>
    apiClient.get('/verification/prompt').then((r) => r.data),

  submitVerification: (imageDataUrl: string, prompt: string) =>
    apiClient.post('/verification/submit', { imageDataUrl, prompt }).then((r) => r.data),

  getStatus: () => apiClient.get('/verification/status').then((r) => r.data),
};

export default verificationApi;
